module.exports = __webpack_public_path__ + "static/img/53398cfa3c1d9ff329e63734f9ab73bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sol_icon1.png
// module id = kh3/
// module chunks = 1